module.exports = __webpack_public_path__ + "static/media/LinkedIn-icon.4e834a0d.svg";